// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import {isIOS} from './api/browser.js'
Vue.use(ElementUI);
Vue.config.productionTip = false

router.afterEach((to, from)=>{
  if((isIOS()&&navigator.userAgent.indexOf("wxwork")==-1)){
    //IOS微信不处理
    return;
  }
  //alert("enter router")
  $.ajax({
      type : "get",
      url : "https://liveshare-sh.cnfic.com.cn/wx/jsapi/getJsapiTicket?url="+location.href,
      dataType : "jsonp",
      jsonp: "callback",
      jsonpCallback:"success_jsonpCallback",
      success : function(data){
        if(isIOS()||isAndroid()&&navigator.userAgent.indexOf("wxwork")==-1){
          //alert("ios 企业微信或者android 微信")
          wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                  'updateAppMessageShareData',
                  'updateTimelineShareData',
                  "onMenuShareTimeline",
                  'onMenuShareAppMessage'
              ]
          });
        }else{
          //alert("android 企业微信");
          wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                  //企业微信
                  "onMenuShareTimeline",
                  'onMenuShareAppMessage'
              ]
          });
        }
      },
      error:function(jq, status, error){}
  });
  if(isIOS()||isAndroid()&&navigator.userAgent.indexOf("wxwork")==-1){
    wx.ready(function () {
        //alert("ios企业微信 android 微信")
        wx.updateAppMessageShareData({...shareData, success:function(){}});
        wx.updateTimelineShareData({...shareData, success:function(){}});
        wx.onMenuShareTimeline({...shareData, success:function(){}, cancel:function(){}});
        wx.onMenuShareAppMessage({...shareData, success:function(){}, cancel:function(){}});
    });
  }else{
    wx.ready(function () {
      //alert("android 企业微信");
        //wx.updateAppMessageShareData({...shareData, success:function(){}});
        //wx.updateTimelineShareData({...shareData, success:function(){}});
        wx.onMenuShareTimeline({...shareData, success:function(){}, cancel:function(){}});
        wx.onMenuShareAppMessage({...shareData, success:function(){}, cancel:function(){}});
    });
  }

});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js